var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuStatisticsColor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Statistics_active",
    "data-name": "Statistics active",
    transform: "translate(-2365.001 -7504)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6396",
    "data-name": "Rectangle 6396",
    width: 18,
    height: 18,
    transform: "translate(2365.001 7504)",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_20639",
    "data-name": "Group 20639",
    transform: "translate(2367 7506)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20638",
    "data-name": "Group 20638",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20637",
    "data-name": "Group 20637",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_100938",
    "data-name": "Path 100938",
    d: "M1.411,0H4.523a1.411,1.411,0,1,1,0,2.822H1.411A1.411,1.411,0,0,1,1.411,0Z",
    transform: "translate(4 14.053) rotate(-90)",
    fill: "#3381aa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_111",
    "data-name": "Rectangle 111",
    width: 8.934,
    height: 2.822,
    rx: 1.411,
    transform: "translate(0 14.053) rotate(-90)",
    fill: "#c267ef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_100937",
    "data-name": "Path 100937",
    d: "M1.411,0H8.995a1.411,1.411,0,1,1,0,2.822H1.411A1.411,1.411,0,0,1,1.411,0Z",
    transform: "translate(8 14.053) rotate(-90)",
    fill: "#37dc79"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_57",
    "data-name": "Rectangle 57",
    width: 14.053,
    height: 2.822,
    rx: 1.411,
    transform: "translate(12 14.053) rotate(-90)",
    fill: "#ee5252"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuStatisticsColor);
export default __webpack_public_path__ + "static/media/menu-statistics-color.7e43ad0b06e098d8f96cdbb0d1d81263.svg";
export { ForwardRef as ReactComponent };